module.exports = __webpack_public_path__ + "img/4d3ac08.png";